import { useEffect, useState } from 'react';
import { invoicesAPI, soCreateAPI } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { toast } from 'sonner';

export function ChangeSerialDialog({ target, invoice, onClose, onChanged }) {
  const [serials, setSerials] = useState([]);
  const [loading, setLoading] = useState(false);
  const [q, setQ] = useState('');
  const [pick, setPick] = useState('');
  const [saving, setSaving] = useState(false);
  const loc = invoice.clinic_name || invoice.location_name || invoice.branch_name || '';

  useEffect(() => {
    if (!target) return;
    setPick(''); setQ(''); setLoading(true);
    soCreateAPI.availableSerials({ item_id: target.item.item_id || '', item_name: target.item.name || '', location: loc })
      .then(({ data }) => setSerials(data.serial_numbers || []))
      .catch(() => setSerials([]))
      .finally(() => setLoading(false));
  }, [target, loc]);

  const save = async () => {
    setSaving(true);
    try {
      await invoicesAPI.changeSerial(invoice.id || invoice.invoice_id, { line_index: target.index, old_serial: target.serial, new_serial: pick });
      toast.success(`Serial changed to ${pick}`);
      onChanged();
      onClose();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Failed to change serial');
    } finally { setSaving(false); }
  };

  const shown = serials.filter(s => s.toLowerCase().includes(q.toLowerCase()));
  return (
    <Dialog open={!!target} onOpenChange={o => { if (!o) onClose(); }}>
      <DialogContent className="max-w-md" data-testid="change-serial-dialog">
        <DialogHeader>
          <DialogTitle>Change Serial</DialogTitle>
          <DialogDescription>
            {target?.item.name} · current <span className="font-mono font-semibold">{target?.serial}</span> · in stock at {loc || '—'}
          </DialogDescription>
        </DialogHeader>
        <Input placeholder="Search serial..." value={q} onChange={e => setQ(e.target.value)} data-testid="change-serial-search" />
        <div className="max-h-64 overflow-y-auto border border-[#E2E8F0] rounded-md divide-y" data-testid="change-serial-list">
          {loading ? <p className="p-3 text-sm text-[#64748B]">Loading...</p>
            : shown.length === 0 ? <p className="p-3 text-sm text-[#64748B]" data-testid="change-serial-empty">No in-stock serials for this item at this branch</p>
              : shown.map(s => (
                <button key={s} type="button" onClick={() => setPick(s)} data-testid={`change-serial-option-${s}`}
                  className={`w-full text-left px-3 py-2 text-sm font-mono transition-colors ${pick === s ? 'bg-[#0F4C81] text-white' : 'hover:bg-[#F1F5F9]'}`}>
                  {s}
                </button>
              ))}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="change-serial-cancel">Cancel</Button>
          <Button onClick={save} disabled={!pick || saving} className="bg-[#0F4C81]" data-testid="change-serial-save">
            {saving ? 'Saving...' : 'Save'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
